import Box from "@mui/material/Box";
import JsonLd from "components/JsonLd";
import LanguageContext from "components/LanguageContext";
import PageVersionContext from "components/PageVersionContext";
import SiteContext from "components/SiteContext";
import Link from "components/templatesComponents/Link";
import PropTypes from "prop-types";
import React, { useContext, useState } from "react";
import t from "utils/locales/translation.json";
import { createQueryParams, queryParamPage, queryParamSite } from "utils/urlUtils";

const BreadcrumbItem = (props) => {
  const { item, siteId, bo = false, ...others } = props;

  const convertFullPath = `/?${createQueryParams({
    [queryParamSite]: siteId,
    [queryParamPage]: item.pageId,
  })}`;

  return (
    <li title={item.title}>
      <Link
        basic
        size="xs"
        className="fr-breadcrumb__link"
        title={item.title}
        url={bo ? convertFullPath : item.fullPath || "/"}
        {...others}
      >
        {item.title}
      </Link>
    </li>
  );
};

BreadcrumbItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    fullPath: PropTypes.string,
    pageId: PropTypes.string,
  }).isRequired,
  siteId: PropTypes.string.isRequired,
  bo: PropTypes.bool,
};

const Breadcrumb = (props) => {
  const { bo = false } = props;
  const { currentPageVersion } = useContext(PageVersionContext);
  const { breadcrumb = [] } = currentPageVersion || {};
  const { language } = useContext(LanguageContext);
  const site = useContext(SiteContext);
  const { id: siteId } = site;

  const [displayBreadcrumb, setDisplayBreadcrumb] = useState(false);

  const structuredData = `{
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [${
      breadcrumb &&
      breadcrumb.reduce(
        (str, breadcrumbItem, index) =>
          `${str}
        {
          "@type": "ListItem",
          "position": ${index + 1},
          "name": "${breadcrumbItem.title}",
          "item": "${site.host}${breadcrumbItem.fullPath || "/"}"
        }${breadcrumb.length !== index + 1 ? "," : ""}`,
        "",
      )
    }
    ]
  }`;

  return breadcrumb && breadcrumb.length > 1 ? (
    <Box sx={{ "& .fr-breadcrumb": { mt: 0, pt: 3 } }}>
      <nav id="breadcrumb" role="navigation" className="fr-breadcrumb" aria-label={t[language].components.breadcrumb}>
        <Box
          component="button"
          type="button"
          className="fr-breadcrumb__button"
          sx={{ display: { xs: !displayBreadcrumb ? "inline-block" : "none", md: "none" } }}
          onClick={() => setDisplayBreadcrumb(true)}
        >
          Voir le fil d’Ariane
        </Box>
        <Box
          component="ol"
          className="fr-breadcrumb__list"
          sx={{ display: { xs: displayBreadcrumb ? "block" : "none", md: "block" } }}
        >
          {breadcrumb.map((breadcrumbItem, index) =>
            index !== breadcrumb.length - 1 ? (
              <BreadcrumbItem key={breadcrumbItem.pageId} item={breadcrumbItem} siteId={siteId} bo={bo} />
            ) : (
              <li key={breadcrumbItem.pageId}>
                <a title={breadcrumbItem.title} className="fr-breadcrumb__link" aria-current="page">
                  {breadcrumbItem.title}
                </a>
              </li>
            ),
          )}
        </Box>
      </nav>
      <JsonLd structuredData={structuredData} />
    </Box>
  ) : (
    <Box sx={{ height: 84 }} />
  );
};

Breadcrumb.propTypes = {
  bo: PropTypes.bool,
};

export default Breadcrumb;
